import { Button } from "@material-ui/core";
import i18next from "i18next";
import { FC, memo } from "react";
import { goToMessenger } from "../../../../libs/services";
import { areEqual } from "../../../../libs/utils";
import styles from "./styles.module.scss";

const NotFoundComponent: FC = () => {
  return (
    <div className={`d-flex flex-wrap flex-column justify-content-center align-items-center ${styles.container}`}>
      <img src={require("../../../../assets/img/404.png").default} alt="" className={styles.image} />
      <Button variant="contained" color="primary" className="mt-3" onClick={() => goToMessenger()}>
        {i18next.t("global.return_to_igap")}
      </Button>
    </div>
  );
};

export default memo(NotFoundComponent, areEqual);
